import newtonsCradle from '../elements/newtonsCradle.js';
newtonsCradle.register();
